import React, { useState, useEffect, useMemo } from 'react';
import {
    Row,
    Col,
    Container,
} from 'reactstrap';
import CommonService from 'services/CommonService';
import CustomLoader from 'components/Common/CustomLoader';
import UseDebounce from 'components/shared/UseDebounce';
import { IColumnModel } from 'models/IColumnModel';
import { ISearchModel } from 'models/ISearch.Model';
import CustomDataTable from 'components/shared/CustomDataTable';
import { aes_encryption } from '../../helpers/Helper';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { IImportModel } from 'models/Import.Model';
import '../Import/Import.css'
function ImportTransactionView() {
    const { id } = useParams<any>();
    const [isload, setIsLoad] = useState(false);
    const [validateData, setValidateData] = useState<Array<any>>([]);
    const [modal, setModal] = useState(false);
    const [excelErrors, setExcelErrors] = useState<Array<{ Id: any, Err: any }>>([]);


    const editHandler = (row: any) => {
        const id = row?.id;
        if (id) {
            const url = `/import-history/${aes_encryption(id)}`;
            window.open(url, '_blank');
        } else {
            console.warn('ID not found in row:', row);
        }
    };

    const changesMade = (val1, val2) => {
        if (val1 != val2) {
            return 'changes-made';
        }
        return "";
    }

    const percentageHandler = (LiveMinValue, MinimumValue) => {
        if (LiveMinValue != MinimumValue) {
            let percentage = ((MinimumValue - LiveMinValue) / LiveMinValue) * 100;
            let color = ""
            if ((percentage > 0 && percentage < 2) || (percentage < 0 && percentage > -2)) {
                color = 'highlight-green';
            }
            if ((percentage >= 2 && percentage <= 5) || (percentage <= -2 && percentage >= -5)) {
                color = 'highlight-orange';
            }
            if (percentage > 5 || percentage < -5) {
                color = 'highlight-red';
            }

            return <p className={color}>({percentage.toFixed(2)}%)</p>
        }
        return ""
    }

    const toISODateString = (dateStr: string) => {
        const isoDate = moment(dateStr, "MM/DD/YYYY hh:mm:ss A").format("YYYY-MM-DDTHH:mm:ss");
        return isoDate;
    }

    const statusValidator = (items: Array<IImportModel>) => {
        const err = (id, err) => {
            return {
                Id: id,
                Err: err
            }
        }
        for (let item of items) {

            if (item.Duplicate == true) {
                excelErrors.push(err(item.Id, "You couldn't change the following columns: Id, Product, Brand, Series, Model, and Variants. Please review the highlighted column to correct the mistake."));
            }

            if (item.ProductTypeName != item.CurrentProductTypeName) {
                excelErrors.push(err(item.Id, "ProductTypeName is Empty or Changed"));
            }
            if (item.BrandMasterName != item.CurrentBrandMasterName) {
                excelErrors.push(err(item.Id, "BrandMasterName is Empty or Changed"));
            }
            if (item.BrandSeriesName != item.CurrentBrandSeriesName) {
                excelErrors.push(err(item.Id, "BrandSeriesName is Empty or Changed"));
            }
            if (item.SeriesModelName != item.CurrentSeriesModelName) {
                excelErrors.push(err(item.Id, "SeriesModelName is Empty or Changed"));
            }
            if (item.Name != item.CurrentName) {
                excelErrors.push(err(item.Id, "Name is Empty or Changed"));
            }
            if (item.MinimumValue > item.MaximumValue) {
                excelErrors.push(err(item.Id, "Minimum Price is greater than maximum price"));
            }

            if (item.Errors?.length > 0) {
                for (let eItem of item.Errors) {
                    excelErrors.push(err(item.Id, eItem));
                }
            }
        }
        setExcelErrors(excelErrors);
        setValidateData(items);
    }


    const GetImportTransactionByImportHistoryId = (encryptedId:any) => {
        let searchCriteria = {
            rowsPerPage: 10,
            offsetStart: 0,
            searchText: "",
            sortOrder: "DESC",
            SortOrderColumn: "Modified"
        }
        CommonService.postWithEntityandSingleQueryParam("sell", "GetImportTransactionByImportHistoryId", searchCriteria,"importHistoryId", encodeURIComponent(encryptedId)).then((res) => {
            if(res.status == 200){
                setValidateData(res.data);
            }
        })
    }

    useEffect(() => {
        if (id) {
            GetImportTransactionByImportHistoryId(id);
        }
    }, [id])

    return (
        <div className="page-content">
            <CustomLoader isOpen={isload} />
            <Container fluid className="p-0">
                <div className="d-flex justify-content-between">
                    <h5 className="fw-semibold text-dofy dofy-admin-font-md mb-3" style={{ whiteSpace: "nowrap" }}>Import Transaction</h5>
                </div>
                <div className="scrollable-container">
                    <table className="ex-data-table">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Product</th>
                                <th>Brand</th>
                                <th>Series</th>
                                <th>Model</th>
                                <th>Variants</th>
                                <th>Live Min</th>
                                <th>Cur Min</th>
                                <th>Live Max</th>
                                <th>Cur Max</th>
                                <th>Display For Sale</th>
                                <th>Restricted For Min Price</th>
                                <th>Expiration Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {validateData.map((item, index) => (
                                <tr key={index}>
                                    <td className={changesMade(item.Id, item.CurrentId)}>{item.Id}</td>
                                    <td className={changesMade(item.ProductTypeName, item.CurrentProductTypeName)}>{item.ProductTypeName}</td>
                                    <td className={changesMade(item.BrandMasterName, item.CurrentBrandMasterName)}>{item.BrandMasterName}</td>
                                    <td className={changesMade(item.BrandSeriesName, item.CurrentBrandSeriesName)}>{item.BrandSeriesName}</td>
                                    <td className={changesMade(item.SeriesModelName, item.CurrentSeriesModelName)}>{item.SeriesModelName}</td>
                                    <td className={changesMade(item.Name, item.CurrentModelVariantName)}>{item.Name}</td>
                                    <td>{item.MinimumValue}</td>
                                    <td>{item.CurrentMinimumValue} {percentageHandler(item.MinimumValue, item.CurrentMinimumValue)}</td>
                                    <td>{item.MaximumValue}</td>
                                    <td>{item.CurrentMaximumValue} {percentageHandler(item.MaximumValue, item.CurrentMaximumValue)}</td>
                                    <td className={changesMade(item.DisplayForSale, item.CurrentDisplayForSale)}>{item.CurrentDisplayForSale ? 'Yes' : 'No'}</td>
                                    <td className={changesMade(item.IsRestricted, item.CurrentIsRestricted)}>{item.CurrentIsRestricted ? 'Yes' : 'No'}</td>
                                    <td className={changesMade(moment(item.EndDate).format("MMM-DD-YYYY"),moment(item.CurrentEndDate).format("MMM-DD-YYYY"))}>{item.CurrentEndDate ? moment(item.CurrentEndDate).format("MMM-DD-YYYY") : ""}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Container>
        </div>
    );
};

export default ImportTransactionView;